import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { stpfcapprovaldetails,stpfcApprovalEmployeeWiseDetails } from '../../redux/slice/stpfcdetails';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from "react";


const SFCApprovalDetails = ({ onClose, employeedata }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 mt-5 z-50">
      {employeedata && Object.keys(employeedata).length > 0 && (
        <div className="bg-white rounded-md shadow-lg h-[450px] p-5 relative sm:w-[370px] sm:p-4 xs:w-[300px] xs:p-3">
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-600 hover:text-gray-900">
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </button>
          <h2 className="text-baseMd font-semibold text-primary mb-3">SFC Approval Details</h2>
          <div className="w-full h-[0.5px] bg-line-color mb-3 -mt-1"></div>

          <div className="grid grid-cols-2 gap-x-10 gap-y-3 text-[12px] text-gray-600 smAndMd:text-[12px]">
            <p className="font-medium text-left">From City </p> <p className="text-right">{employeedata.fromCity }</p>
            <p className="font-medium text-left">To City </p> <p className="text-right">{employeedata.toCity}</p>
            <p className="font-medium text-left">Category </p> <p className=" text-right">{employeedata.category}</p>
            <p className="font-medium text-left">Travel Mode </p> <p className=" text-right">{employeedata.transportType}</p>
            <p className="font-medium text-left">No. of Chemists </p> <p className=" text-right">{employeedata.noOfChemists}</p>
            <p className="font-medium text-left">No. of Doctors </p> <p className=" text-right">{employeedata.noOfDoctors}</p>
            <p className="font-medium text-left">Daily Allowance </p> <p className=" text-right">
            <span>₹ </span> {employeedata.allowance}</p>
            <p className="font-medium text-left">One Way Distance </p> <p className=" text-right">{employeedata.oneWayDistance} <span>KM</span></p>
            <p className="font-medium text-left">Two Way Distance </p> <p className=" text-right">{employeedata.twoWayDistance} <span>KM</span></p>
            <p className="font-medium text-left">One Way Fare </p> <p className=" text-right">
            <span>₹ </span> {employeedata.oneWayFare}</p>
            <p className="font-medium text-left">Two Way Fare </p> <p className=" text-right">
            <span>₹ </span> {employeedata.twoWayFare}</p>
            </div>

            <div className="w-full h-[0.5px] bg-line-color my-3" />
            <div className="grid grid-cols-2 gap-x-10 gap-y-3 text-[14px] text-gray-600 smAndMd:text-[14px]">
            <p className="font-semibold text-left text-black">Total</p> <p className="font-semibold text-right  text-black">
            <span>₹ </span> {employeedata.total}</p>
            </div>
        </div>
      )}
    </div>
  );
};

export default SFCApprovalDetails;
